import React from 'react';
import classNames from 'classnames';

export interface ListProps {
  id?: string;
  unordered?: boolean;
  ordered?: boolean;
  type?: 'circle' | 'disc' | 'none' | 'square';
  className?: string;
  children?: React.ReactNode;
}

const List: React.FC<ListProps> = (props: ListProps) => {
  const { id, className, children, unordered, ordered, type } = props;

  const listClass = classNames(
    'ui-list',
    {
      'ui-list--unordered': unordered,
      'ui-list--ordered': ordered,
      [`ui-list-type--${type}`]: type,
    },
    className
  );

  if (ordered) {
    return (
      <ol id={id} className={listClass}>
        {children}
      </ol>
    );
  }

  return (
    <ul id={id} className={listClass}>
      {children}
    </ul>
  );
};

export default List;
